import { getItem } from "../utils/storage.helper";

const isAuthenticated = (): boolean => {
  const data = getItem(import.meta.env.VITE_ACCESSTK);
  return Boolean(data && data.rsa);
};

export default isAuthenticated;
